
export default function () {
      return {
        visitorsList:[],
        
      }
 }